/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_Never_NoteInputs */

const en_us2_plan_edit_never_note = /** @type {(inputs: Plan_Edit_Never_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick another; this one leaves the suggestions`)
};

const pt_br2_plan_edit_never_note = /** @type {(inputs: Plan_Edit_Never_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troque por outro; este sai das sugestões`)
};

const es_419_plan_edit_never_note = /** @type {(inputs: Plan_Edit_Never_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cámbialo por otro; este sale de las sugerencias`)
};

const pt_pt2_plan_edit_never_note = /** @type {(inputs: Plan_Edit_Never_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolhe outro; este sai das sugestões`)
};

const fr_fr2_plan_edit_never_note = /** @type {(inputs: Plan_Edit_Never_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisis-en un autre ; celui-ci sort des suggestions`)
};

const de_de2_plan_edit_never_note = /** @type {(inputs: Plan_Edit_Never_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähl eine andere; diese verschwindet aus den Vorschlägen`)
};

const it_it2_plan_edit_never_note = /** @type {(inputs: Plan_Edit_Never_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegline un altro; questo esce dai suggerimenti`)
};

/**
* | output |
* | --- |
* | "Pick another; this one leaves the suggestions" |
*
* @param {Plan_Edit_Never_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_never_note = /** @type {((inputs?: Plan_Edit_Never_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_Never_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_never_note(inputs)
	if (locale === "es-419") return es_419_plan_edit_never_note(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_never_note(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_never_note(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_never_note(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_never_note(inputs)
	return en_us2_plan_edit_never_note(inputs)
});
export { plan_edit_never_note as "plan-edit.never_note" }